import React, { useEffect, useState } from 'react';

// Import template styles
import './classic/src/index.css';
import './classic/src/App.css';
import Header from './classic/src/components/Header';
import Hero from './classic/src/components/Hero';
import Experience from './classic/src/components/Experience';
import Education from './classic/src/components/Education';
import Skills from './classic/src/components/Skills';
import Contact from './classic/src/components/Contact';

const ClassicTemplate = ({ subdomain }) => {
    const [hero, setHero] = useState(null);
    const [experiences, setExperiences] = useState([]);
    const [education, setEducation] = useState([]);
    const [competencies, setCompetencies] = useState([]);
    const [tools, setTools] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isActive = true;
        const load = async () => {
            try {
                const [h, ex, ed, co, to, la] = await Promise.all([
                    fetch(`https://personal-site-saas-api.l5819033.workers.dev/api/site/${subdomain}/hero`).then(r => r.ok ? r.json() : null),
                    fetch(`https://personal-site-saas-api.l5819033.workers.dev/api/site/${subdomain}/experiences`).then(r => r.ok ? r.json() : []),
                    fetch(`https://personal-site-saas-api.l5819033.workers.dev/api/site/${subdomain}/education`).then(r => r.ok ? r.json() : []),
                    fetch(`https://personal-site-saas-api.l5819033.workers.dev/api/site/${subdomain}/competencies`).then(r => r.ok ? r.json() : []),
                    fetch(`https://personal-site-saas-api.l5819033.workers.dev/api/site/${subdomain}/tools`).then(r => r.ok ? r.json() : []),
                    fetch(`https://personal-site-saas-api.l5819033.workers.dev/api/site/${subdomain}/languages`).then(r => r.ok ? r.json() : []),
                ]);
                if (!isActive) return;
                setHero(h);
                setExperiences(ex);
                setEducation(ed);
                setCompetencies(co);
                setTools(to);
                setLanguages(la);
                setLoading(false);
            } catch {}
        };
        load();
        return () => { isActive = false; };
    }, [subdomain]);

    if (loading) {
        return (
            <div>
                <section className="hero" style={{paddingTop:70}}>
                    <div className="container">
                        <div className="hero-content" style={{width:'100%', maxWidth:1100}}>
                            <div className="ex-skeleton ex-skel-title" />
                            <div className="ex-skeleton ex-skel-line" />
                            <div className="ex-skeleton ex-skel-line" style={{width:'70%', margin:'0 auto'}} />
                        </div>
                    </div>
                </section>
                <section className="experience"><div className="container"><div className="ex-skeleton ex-skel-title" /><div className="ex-skeleton ex-skel-card" /></div></section>
            </div>
        );
    }

    return (
        <div>
            <Header />
            <Hero heroData={hero} />
            <Experience experiences={experiences} />
            <Education education={education} />
            <Skills competencies={competencies} tools={tools} languages={languages} />
            <Contact subdomain={subdomain} />
        </div>
    );
};

export default ClassicTemplate;
